import React from "react";
import { CheckIcon, GlobeIcon, LockIcon } from "lucide-react";
import { offerItems, images } from "../../data/content";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
const perks = ["One-time payment", "Lifetime access", "No monthly fees", "Immediate digital access", "7-Day Guarantee"];
export function Offer() {
  return <section id="offer" className="w-full bg-navy px-4 py-16 sm:py-20" data-id="element-202" data-mp="3a4dxa9j5yi6j">
      <div className="mx-auto max-w-xl" data-id="element-203" data-mp="3f4a3mffc2lp9">
        <h2 className="text-center font-serif text-3xl font-black leading-tight text-white sm:text-4xl" data-id="element-204" data-mp="3f38mpubmz4zm">
          Special launch offer: <em className="text-[#5aa2ff]" data-id="element-205" data-mp="3jxcw0k8djp3v">everything you get today</em>
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white shadow-[0_30px_60px_-20px_rgba(0,0,0,0.5)]" data-id="element-206" data-mp="3nw2889hof0lx">
          <img src={images.mockup} alt="Everything included in Implant Case Decision" className="w-full bg-white" data-id="element-207" data-mp="3stu053ibmmq4" />

          <div className="px-5 pb-7 sm:px-8" data-id="element-208" data-mp="1klglajuwscjv">
            <ul className="divide-y divide-slate-200 border-y border-slate-200" data-id="element-209" data-mp="1km9k8ynmlxrg">
              {offerItems.map(item => <li key={item.title} className="flex items-center justify-between gap-4 py-3.5" data-id="element-210" data-mp="1fl2cgzlhgyks">
                  <span className="flex items-start gap-2 text-[16px] font-semibold text-ink" data-id="element-211" data-mp="1bl1y1eydwndq">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-accept" strokeWidth={3} aria-hidden="true" data-id="element-212" data-mp="16njnjk4py03m" />
                    {item.title}
                  </span>
                  <span className="shrink-0 text-[15px] font-bold text-muted" data-id="element-213" data-mp="1zbfiajaq9hxr">${item.value}</span>
                </li>)}
              <li className="flex items-center justify-between py-3.5" data-id="element-214" data-mp="1uhjnfpprgb6t">
                <span className="text-[16px] font-black uppercase text-ink" data-id="element-215" data-mp="1pjrwoz0uqv47">Total value</span>
                <s className="text-lg font-black text-refer" data-id="element-216" data-mp="2n0qmkaradugn">$294</s>
              </li>
            </ul>

            <p className="mt-6 text-center text-[16px] text-muted" data-id="element-217" data-mp="2i8gqeczkvy5x">But today, you don't have to pay $294.</p>
            <p className="mt-1 text-center text-sm font-bold uppercase tracking-wide text-ink" data-id="element-218" data-mp="3160nzquqkea6">Get complete access for only</p>
            <p className="mt-1 text-center font-serif text-[80px] font-black leading-none text-accept" data-id="element-219" data-mp="366ekqcqw01sw">
              $27<span className="ml-1 align-top font-sans text-xl font-bold text-muted" data-id="element-220" data-mp="2wer1gz4hhr2i">USD</span>
            </p>

            <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-221" data-mp="2if96g20lhhkp">
              {perks.map(p => <li key={p} className="flex items-center gap-1.5 text-sm font-semibold text-ink" data-id="element-222" data-mp="2necc9ooefrtq">
                  <CheckIcon className="h-4 w-4 text-accept" strokeWidth={3} aria-hidden="true" data-id="element-223" data-mp="29f2z6xvhpdtz" />
                  {p}
                </li>)}
            </ul>

            <div className="mt-6" data-id="element-224" data-mp="7my6vla2weiq">
              <CtaButton label="Yes — I want Implant Case Decision™" data-id="element-225" data-mp="7nzns6drzv8d" />
              <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-sm text-muted" data-id="element-226" data-mp="bo9q992d03ih">
                <LockIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-227" data-mp="1w62h2g4bbzhj" />
                Secure checkout · Immediate access · 7-Day Guarantee
              </p>
            </div>

            <div className="mt-7" data-id="element-228" data-mp="25w3t29je5rg3">
              <Countdown data-id="element-229" data-mp="25xf5exqwk7it" />
            </div>

            <div className="mt-6" data-id="element-230" data-mp="25y889nmqqcvo">
              <ScarcityBar data-id="element-231" data-mp="215f1ku7pougy" />
            </div>

            <div className="mt-4 flex items-start gap-2.5 rounded-xl bg-brand-light p-3.5" data-id="element-232" data-mp="214c8qgqtwhye">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-233" data-mp="2fsqdix7t2ghl" />
              <p className="text-sm leading-snug text-ink" data-id="element-234" data-mp="2auyjnxnlokar">
                <strong data-id="element-235" data-mp="2ovrfclpn1lfg">Automatic currency conversion:</strong> the price is shown and charged in your local currency at checkout.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}